module.exports = __webpack_public_path__ + "static/media/lock.a37abe39.svg";